(function(){
  var root=document.getElementById('wb-col'); if(!root)return;
  var items=[].slice.call(root.querySelectorAll('.wb-item'));
  var rail=root.querySelector('.wb-filters');
  var groups={};
  [].slice.call(rail.querySelectorAll('.wb-fgroup[data-g]')).forEach(function(g){
    var k=g.getAttribute('data-g');
    if(k==='price'||k==='filterfit')return;
    groups[k]=[].slice.call(g.querySelectorAll('.wb-chk'));
  });
  function itemVals(it,g){
    if(g==='seating'){return [it.getAttribute('data-seating')||'',it.getAttribute('data-lsub')||''];}
    if(g==='features'){return (it.getAttribute('data-features')||'').split(' ');}
    return [it.getAttribute('data-'+g)||''];
  }
  /* price bounds from real data */
  var rmin=rail.querySelector('.wb-rgmin'),rmax=rail.querySelector('.wb-rgmax');
  var rfill=rail.querySelector('.wb-rfill'),rminv=rail.querySelector('.wb-rminv'),rmaxv=rail.querySelector('.wb-rmaxv');
  /* W6-5 (18 Sep 2026): a card whose price is 0, missing or unreadable is PRICELESS, not free.
     parseInt('')||0 used to turn all three into a real ₹0, which then took part in the range and
     in the price test — so such a piece was quoted at zero and vanished from the grid the moment
     the shopper lifted the bottom handle off ₹0. priceOf() returns null for all three; a null
     price is excluded from the bound below and always passes the price test in matches(). */
  function priceOf(it){
    var raw=it.getAttribute('data-price');
    if(raw===null||raw===undefined)return null;
    raw=String(raw).replace(/[^0-9.]/g,'');
    if(raw==='')return null;
    var p=parseFloat(raw);
    if(!isFinite(p)||p<=0)return null;
    return p;
  }
  var top=0;
  items.forEach(function(it){var p=priceOf(it);if(p!==null&&p>top)top=p;});
  top=Math.ceil(top/10000)*10000;
  /* W4-5: the floor was 100000, so a ₹7,046 bedside table sat in 7% of the slider and could not
     be filtered. The bound now comes from the real maximum; 10000 only guards an empty grid. */
  if(top<=0)top=10000;
  rmin.max=top;rmax.max=top;rmax.value=top;
  /* W4-15: matches() used to call priceUI() — four DOM writes — on every one of its ~940
     invocations per pass. The range is read once per pass and held here instead. */
  var prange=[0,top];
  function inr(n){return '₹'+Number(n).toLocaleString('en-IN');}
  function priceUI(){
    var a=parseInt(rmin.value,10),b=parseInt(rmax.value,10);
    if(a>b){var t=a;a=b;b=t;}
    rminv.textContent=inr(a);rmaxv.textContent=inr(b);
    rfill.style.left=(a/top*100)+'%';rfill.style.right=(100-b/top*100)+'%';
    prange=[a,b];
    return prange;
  }
  function selected(g){
    return groups[g].filter(function(c){return c.classList.contains('on');}).map(function(c){return c.getAttribute('data-v');});
  }
  function matches(it,skipG){
    var p=priceOf(it);
    /* priceless: no price to test against, so the price row never hides it */
    if(p!==null&&items.length&&(p<prange[0]||p>prange[1]))return false;
    for(var g in groups){
      if(g===skipG)continue;
      var sel=selected(g);
      if(!sel.length)continue;
      var vals=itemVals(it,g),hit=false;
      sel.forEach(function(v){if(vals.indexOf(v)>-1)hit=true;});
      if(!hit)return false;
    }
    return true;
  }
  function counts(){
    for(var g in groups){
      groups[g].forEach(function(c){
        var v=c.getAttribute('data-v'),n=0;
        items.forEach(function(it){
          if(itemVals(it,g).indexOf(v)>-1&&matches(it,g))n++;
        });
        var ct=c.querySelector('.wb-ct');if(ct)ct.textContent=n;
      });
    }
  }
  function apply(){
    priceUI();
    var shown=0;
    items.forEach(function(it){
      var ok=matches(it,null);
      it.classList.toggle('wb-hide',!ok);
      if(ok)shown++;
    });
    var empty=root.querySelector('.wb-cempty');
    if(empty)empty.hidden=!(items.length&&shown===0);
    counts();
    /* chip active state */
    [].slice.call(root.querySelectorAll('.wb-mchip[data-open]')).forEach(function(ch){
      var g=ch.getAttribute('data-open');
      if(g==='all'||g==='price')return;
      ch.classList.toggle('on',selected(g).length>0);
    });
    /* W2-3: the AR probe re-labels the .wb-room pills; tell it the grid has re-rendered. */
    root.dispatchEvent(new CustomEvent('woodbun:grid-rendered',{bubbles:true}));
  }
  for(var g in groups){
    groups[g].forEach(function(c){
      c.addEventListener('click',function(){c.classList.toggle('on');apply();});
    });
  }
  /* W4-15: 'input' fires continuously while dragging. The labels and the fill follow the drag;
     the filter and the facet counts run once, when the handle is let go. */
  [rmin,rmax].forEach(function(r){r.addEventListener('input',priceUI);r.addEventListener('change',apply);});
  function clearAll(){
    for(var g in groups){groups[g].forEach(function(c){c.classList.remove('on');});}
    rmin.value=0;rmax.value=top;apply();
  }
  var cl=rail.querySelector('.wb-fclear');if(cl)cl.addEventListener('click',clearAll);
  var cl2=root.querySelector('.wb-fclear2');if(cl2)cl2.addEventListener('click',clearAll);
  /* mobile sheet */
  function fsClose(){document.body.classList.remove('wb-fsopen');rail.classList.remove('open');rail.removeAttribute('data-open');
    [].slice.call(rail.querySelectorAll('.wb-fgroup')).forEach(function(x){x.classList.remove('shown');});}
  [].slice.call(root.querySelectorAll('.wb-mchip')).forEach(function(ch){
    ch.addEventListener('click',function(){
      var g=ch.getAttribute('data-open');
      document.body.classList.add('wb-fsopen');rail.classList.add('open');rail.setAttribute('data-open',g);
      if(g!=='all'){var el=rail.querySelector('.wb-fgroup[data-g="'+g+'"]');if(el)el.classList.add('shown');}
    });
  });
  var scrim=root.querySelector('.wb-fscrim');if(scrim)scrim.addEventListener('click',fsClose);
  var ap=rail.querySelector('.wb-fsapply');if(ap)ap.addEventListener('click',fsClose);
  /* sort */
  var sort=root.querySelector('.wb-sort');
  if(sort){
    var cur=new URLSearchParams(window.location.search).get('sort_by')||'';
    sort.value=cur;
    if(sort.value!==cur)sort.value='';
    sort.addEventListener('change',function(){
      var u=new URL(window.location.href);
      if(sort.value)u.searchParams.set('sort_by',sort.value);else u.searchParams.delete('sort_by');
      window.location.href=u.toString();
    });
  }
  apply();
})();
